module.exports = __webpack_public_path__ + "img/scary-night.228f93f5.png";